export default {
    SET_APP_UPDATE_STATE: (state, boolean) => {
        state.isAppUpdated = boolean
    },

    SHOW_NOTIFICATION: (state, payload) => {
        state.notification.show = false // ukryj poprzedni komunikat

        setTimeout(() => {
            state.notification.show = true
            state.notification.type = payload.type
            state.notification.message = payload.message
            state.notification.action = payload.action
            state.notification.timeout = payload.timeout
        }, 250)
    },
    HIDE_NOTIFICATION: state => {
        state.notification.show = false
        state.notification.timeout = -1

        setTimeout(() => {
            state.notification.type = ''
            state.notification.message = ''
            state.notification.action = null
        }, 250)
    },

    TOGGLE_MAIN_LOADER: (state, boolean) => {
        state.mainLoader = boolean
    },

    TOGGLE_CIRCULAR_LOADER: (state, boolean) => {
        state.circularLoader = boolean
    },

    FILE_PROGRESS: (state, payload) => {
        state.progress.show = payload.show
        state.progress.value = payload.value
        state.progress.fileName = payload.fileName
    },

    GET_ERROR_CODES_SUCCESS: (state, data) => {
        state.errorCodes = data.results
    },

    SET_DEVICE_CAMERAS: (state, data) => {
        state.hasCamera = data.length > 0
    },

    SAVE_PAGINATION: (state, data) => {
        state.savedPagination.moduleName = data.moduleName
        state.savedPagination.pagination = data.pagination
        state.savedPagination.settings = data.settings
    },
    CLEAR_PAGINATION: state => {
        state.savedPagination.moduleName = null
        state.savedPagination.pagination = null
        state.savedPagination.settings = null
    },
    SET_SELECTED_LIST_ITEM_ID: (state, data) => {
        state.selectedListItemId = data
    },
    CLEAR_SELECTED_LIST_ITEM_ID: state => {
        state.selectedListItemId = null
    }
}
